/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Avatar,
  Button,
  Grid,
  MenuItem,
} from '@material-ui/core';
import {
  acceptApplicantJob,
  checkAffiliateStudentOrganization,
  getCandidatureEntreprise,
  getContractTypes,
  getDegreeLevels,
  getOffresMap,
  getInfosDashboard,
  getTrainings,
  rejectApplicantJob,
} from '@webapps/business';
import {
  ModalSideBar,
  PaginationNumbers,
  TextField,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { Search } from '@material-ui/icons';
import { useStyles } from '@webapps/styles';
import { default as ModalStep } from 'components/Modal';
import Modal from 'components/Modal';
import ProfilName from 'components/Profil/Components/ProfilName';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import AffiliationSend from './Affiliation';
import CardCandidat from './CardCandidat';
import CreateAnnonce from './CreateAnnonce';
import MessageBox from 'components/MessageBox';
import Profil from 'components/Profil';
import Information from 'components/Icons/Information';

const STATUS = [
  { label: 'Tous les statuts', value: 'all' },
  { label: 'En attente', value: 'pending' },
  { label: 'Accepté(e)', value: 'accepted' },
  { label: 'Refusé(e)', value: 'rejected' },
];

const INTEREST_LEVEL = [
  { label: 'Tous les niveaux', value: 'all' },
  { label: 'Neutre', value: 1 },
  { label: 'Faible', value: 2 },
  { label: 'Moyen', value: 3 },
  { label: 'Elevé', value: 4 },
];

const IS_READ = [
  { label: 'Oui et non', value: 'all' },
  { label: 'Oui', value: 'true' },
  { label: 'Non', value: 'false' },
];

const Candidats = ({ handleCandidatLength, idBusinessExternal }) => {
  const {
    classes,
    global,
    cx,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const intl = useIntl();

  const [age, setAge] = useState('');
  const { addToast } = useToast();
  const [degreeLevel, setDegreeLevels] = useState('');
  const [contractType, setContractType] = useState('');
  const { push } = useRouter();

  const location = useLocation();

  const [openSendMessage, setOpenSendMessage] = useState(false);
  const [isRead, setIsRead] = useState('');

  const itemCount = 12;

  const handleViewCvtheque = () => {
    push(ROUTES_PATH.CVTHEQUE_BUSINESS, { params: { id: idUser } });
  };

  const handleCloseSendMessage = () => {
    setOpenSendMessage(false);
  };

  const contactMember = (id, offerId) => {
    setIdSelect(id);
    setIdSelectOffer(offerId);
    setOpenSendMessage(true);
  };

  const {
    data: dataCheckAffiliate,
    isLoading: isLoadingCheckAffiliate,
    isSuccess: isSuccessCheckAffiliate,
    mutateAsync: mutateCheckAffiliate,
  } = useMutation(checkAffiliateStudentOrganization);

  const [stepAffilation, setStepAffiliation] = useState(1);
  const [addModalAffiliation, setAddModalAffiliation] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState();
  const [selectedApplicantOffer, setSelectedApplicantOffer] = useState();

  const handleOpenAddAffiliation = () => {
    setAddModalAffiliation(true);
  };

  const handleCloseAddAffiliation = () => {
    setAddModalAffiliation(false);
  };

  const checkAffilate = async (student, offer) => {
    setSelectedApplicant(student);
    setSelectedApplicantOffer(offer);
    await mutateCheckAffiliate({
      organizationId: idUser,
      studentId: student?.id,
    });
  };

  useEffect(() => {
    if (location?.state?.openCreateAnnonce) {
      handleOpenCreateAnnonce();
      location.state.openCreateAnnonce = false;
    }
  }, [location]);

  useEffect(() => {
    if (isSuccessCheckAffiliate) {
      if (dataCheckAffiliate) {
        addToast({
          status: 'success',
          message: 'Une affiliation est déja en cours avec cet étudiant',
        });
      } else {
        handleOpenAddAffiliation();
      }
    }
  }, [isSuccessCheckAffiliate]);

  const { idUser } = useAuth();
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [offer, setOffer] = useState('');
  const [status, setStatus] = useState('');
  const [interestLevel, setInterestLevel] = useState('');

  const {
    status: load,
    data: { content: candidatures = [], totalElements } = {},
    refetch: refetchCandidatures,
    isFetching,
  } = useQuery(getCandidatureEntreprise, {
    key: [
      'cadidatures',
      page +
      keyword +
      offer +
      status +
      interestLevel +
      isRead +
      contractType +
      degreeLevel,
    ],
    variables: {
      keyword,
      offer,
      status,
      interestLevel,
      contractType,
      isRead,
      degreeLevel,
      id: idBusinessExternal || idUser,
      page: page - 1,
      size: itemCount,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const searchIsRead = (e) => {
    if (e.target.value) {
      e.target.value === 'all' ? setIsRead('') : setIsRead(e.target.value);
      setPage(1);
    }
  };

  const { data: degreeLevels = [] } = useQuery(getDegreeLevels, {
    key: 'levels',
  });
  const searchDegreeLevels = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setDegreeLevels('')
        : setDegreeLevels(e.target.value);
      setPage(1);
    }
  };
  const searchContract = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setContractType('')
        : setContractType(e.target.value);
      setPage(1);
    }
  };

  const { data: { content: offres = [] } = {}, refetch } = useQuery(
    getOffresMap,
    {
      key: ['offres', page],
      variables: {
        [idBusinessExternal ? 'businessesExternals' : 'businesses']: idBusinessExternal || idUser,
        page: page - 1,
        size: 1000,
        status: 'all',
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const {
    isLoading: isLoadingAcceptApplicantCandidature,
    isSuccess: isSuccessAcceptApplicantCandidature,
    mutateAsync: mutateAcceptApplicantCandidature,
  } = useMutation(acceptApplicantJob);

  const {
    isLoading: isLoadingRejectApplicantCandidature,
    isSuccess: isSuccessRejectApplicantCandidature,
    mutateAsync: mutateRejectApplicantCandidature,
  } = useMutation(rejectApplicantJob);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewProfil, setViewProfil] = useState(false);

  const [idSelect, setIdSelect] = useState(0);
  const [idSelectOffer, setIdSelectOffer] = useState(0);
  const [levelInterest, setLevelInterest] = useState(0);
  const [candidatureResponse, setCandidatureResponse] = useState('');
  const [candidatureRead, setCandidatureRead] = useState(false);
  const [openCreateAnnonce, setOpenCreateAnnonce] = useState(false);
  const [stepModal, setStepModal] = useState(1);

  const handleOpenCreateAnnonce = () => {
    setOpenCreateAnnonce(true);
  };

  const handleCloseCreateAnnonce = () => {
    setOpenCreateAnnonce(false);
  };

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const viewCV = (id, offerId, level, candidatureResponse, candidatureRead, candidatureInfo) => {
    setIdSelect(id);
    setIdSelectOffer(offerId);
    setLevelInterest(level);
    setCandidatureResponse(candidatureResponse);
    setCandidatureRead(candidatureRead)
    handleOpenViewProfil();
  };

  const accepetApplicantCandidature = async (idApplicant, idTraining) => {
    await mutateAcceptApplicantCandidature({
      trainingId: idTraining,
      applicantId: idApplicant,
    });
  };

  const rejectApplicantCandidature = async (idApplicant, idTraining) => {
    await mutateRejectApplicantCandidature({
      trainingId: idTraining,
      applicantId: idApplicant,
    });
  };

  useEffect(() => {
    if (isSuccessAcceptApplicantCandidature) {
      addToast({
        status: 'success',
        message: 'Candidature acceptée',
      });
      refetchCandidatures();
    }
  }, [isSuccessAcceptApplicantCandidature]);

  useEffect(() => {
    if (isSuccessRejectApplicantCandidature) {
      addToast({
        status: 'success',
        message: 'Candidature refusée',
      });
      refetchCandidatures();
    }
  }, [isSuccessRejectApplicantCandidature]);

  const searchKeyword = (e) => {
    // if (e.target.value) {
    setKeyword(e.target.value);
    setPage(1);
    // }
  };

  const searchOffer = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setOffer('') : setOffer(e.target.value);
      setPage(1);
    }
  };

  const searchStatus = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all' ? setStatus('') : setStatus(e.target.value);
      setPage(1);
    }
  };

  const searchInterestLevel = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setInterestLevel('')
        : setInterestLevel(e.target.value);
      setPage(1);
    }
  };

  useEffect(() => {
    handleCandidatLength(totalElements);
  }, [totalElements]);

  const getLabelInterestLevel = (level) => {
    switch (level) {
      case 1:
        return 'Neutre';
      case 2:
        return 'Faible';
      case 3:
        return 'Moyen';
      case 4:
        return 'Elevé';
      default:
        return 'Non renseigné';
    }
  };

  return (
    <Grid
      container
      direction="column"
      style={{ rowGap: 20, height: '100%', flexWrap: 'nowrap' }}
    >
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: spacing(1), // espacement entre les éléments
          '@media (max-width: 1028px)': {},
          '@media (max-width: 768px)': {
            flexDirection: 'column',
          },
        })}
      >
        <TextField
          label="Prénom et nom"
          onChange={(e) => searchKeyword(e)}
          size="small"
          variant="outlined"
          borderRadius={30}
          endAdornment={<Search style={{ color: '#5D75A8' }} />}
        />
        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Offre d'emploi en cours"
            name="offer"
            onChange={(e) => searchOffer(e)}
            select
            borderRadius={30}
          >
            <MenuItem value="all">Toutes les offres</MenuItem>
            {offres.map(({ id, job }, index) => (
              <MenuItem key={index} value={id}>
                {job.label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Type de contrat"
            name="contractType"
            onChange={(e) => searchContract(e)}
            variant="outlined"
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les contrats</MenuItem>
            {contractTypes.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Niveau d'étude"
            name="degreeLevels"
            onChange={(e) => searchDegreeLevels(e)}
            variant="outlined"
            select
            borderRadius={30}
          >
            <MenuItem value="all">Tous les niveaux</MenuItem>
            {degreeLevels.map(({ id, label }, index) => (
              <MenuItem key={index} value={id}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Statut de candidature"
            name="status"
            onChange={(e) => searchStatus(e)}
            select
            borderRadius={30}
          >
            {STATUS.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        {/* Niveau d'intérêt */}
        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Niveau d'intérêt"
            name="interest"
            onChange={(e) => searchInterestLevel(e)}
            select
            borderRadius={30}
          >
            {INTEREST_LEVEL.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>

        {/* Profils examinés */}
        <div className={classes.selectInput}>
          <TextField
            fullWidth
            label="Profils examinés"
            name="isRead"
            onChange={(e) => searchIsRead(e)}
            select
            borderRadius={30}
          >
            {IS_READ.map(({ label, value }, index) => (
              <MenuItem key={index} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </div>
      </div>

      <Grid item className={classes.formations} xs>
        <Grid
          className={css({
            // maxHeight: itemCount < totalElements ? 'calc(100vh - 75px - 293px)' : 'calc(100vh - 75px - 243px)',
            // '@media only screen and (max-width: 1279px)': {
            //   maxHeight: itemCount < totalElements ? 'calc(100vh - 75px - 343px)' : 'calc(100vh - 75px - 293px)'
            // },
            '@media only screen and (max-width: 1023px)': {
              // maxHeight: '100%',
            },
            overflow: 'auto',
            height: '100%'
          })}
        >
          {!candidatures?.length && !idBusinessExternal ? (
            <>
              {/* Desktop */}
              <Grid
                container
                className={css({
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  '@media screen and (max-width: 768px)': { display: 'none' },
                })}
              >
                <Grid
                  item
                  xs={12}
                  className={css({
                    display: 'flex',
                    minHeight: 'calc(100vh - 75px - 243px)',
                    '@media only screen and (max-width:1279px)': {
                      minHeight: 'calc(100vh - 75px - 293px)',
                    },
                    '@media only screen and (max-width:1023px)': {
                      minHeight: 'calc(100vh - 75px - 393px)',
                    },
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#F3F7FF',
                    borderRadius: 12,
                    '@media screen and (max-width: 768px)': { padding: 20 },
                  })}
                >
                  <Grid
                    item
                    className={css({
                      backgroundColor: '#FFFFFF',
                      borderRadius: 12,
                      padding: '30.0px',
                      '@media screen and (max-width: 768px)': {
                        padding: '20px',
                      },
                    })}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <h1 className={cx(classes.title, global.title)}>
                        {' '}
                        Commencez à construire votre réseau d'affiliation
                      </h1>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          columnGap: '20px',
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            1. Rechercher un partenariat
                          </p>
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            2. Envoyer une demande en 1 clic
                          </p>
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            3. Gérez vos partenariats facilement
                          </p>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={handleOpenCreateAnnonce}
                            fullWidth
                            className={classes.btn}
                          >
                            Publier une offre
                          </Button>
                        </div>
                        <p>ou</p>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            1. Rechercher un partenariat
                          </p>
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            2. Envoyer une demande en 1 clic
                          </p>
                          <p className={cx(classes.stepStyles, global.infoText)}>
                            3. Gérez vos partenariats facilement
                          </p>
                          <Button
                            color="primary"
                            variant="contained"
                            fullWidth
                            onClick={handleViewCvtheque}
                            className={classes.btn}
                          >
                            CVThèque
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
              {/* Mobile */}
              <Grid
                container
                className={css({
                  display: 'none',
                  justifyContent: 'center',
                  alignItems: 'center',
                  '@media screen and (max-width: 768px)': { display: 'flex' },
                })}
              >
                <Grid
                  item
                  xs={12}
                  style={{
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    backgroundColor: '#F3F7FF',
                    borderRadius: 12,
                  }}
                >
                  <Grid
                    item
                    className={css({
                      backgroundColor: '#FFFFFF',
                      borderRadius: 12,
                      padding: '30.0px',
                      '@media screen and (max-width: 768px)': {
                        padding: '20px',
                      },
                    })}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <h1 className={cx(classes.title, global.title)}>
                        {' '}
                        Commencez à construire votre réseau d'affiliation
                      </h1>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          columnGap: '20px',
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <p className={classes.stepStyles}>
                            1. Rechercher un partenariat
                          </p>
                          <p className={classes.stepStyles}>
                            2. Envoyer une demande en 1 clic
                          </p>
                          <p
                            className={classes.stepStyles}
                            style={{ marginBottom: '20px' }}
                          >
                            3. Gérez vos partenariats facilement
                          </p>
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.btn}
                          >
                            Publier une offre
                          </Button>
                        </div>
                        <p>ou</p>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <p className={classes.stepStyles}>
                            1. Rechercher un partenariat
                          </p>
                          <p className={classes.stepStyles}>
                            2. Envoyer une demande en 1 clic
                          </p>
                          <p
                            className={classes.stepStyles}
                            style={{ marginBottom: '20px' }}
                          >
                            3. Gérez vos partenariats facilement
                          </p>
                          <Button
                            color="primary"
                            variant="contained"
                            className={classes.btn}
                          >
                            Avec la CVthèque
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </>
          ) : (
            <Grid
              container
              className={css({
                backgroundColor: '#F3F7FF',
                borderRadius: 10,
                padding: spacing(2.5, 0, 0, 2.5),
              })}
            >
              {candidatures.map((candidature, index) => (
                <CardCandidat
                  key={index}
                  candidature={candidature}
                  viewCV={viewCV}
                  idBusinessExternal={idBusinessExternal}
                  contactMember={contactMember}
                  addAffiliation={checkAffilate}
                  acceptCandidature={accepetApplicantCandidature}
                  rejectCandidature={rejectApplicantCandidature}
                />
              ))}
              {candidatures.length === 0 && (
                <div className={css({ marginBottom: 20, textAlign: 'center', color: "#152652", width: '100%' })}>Aucun résultat</div>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        noMargin={true}
        page={page}
        pageCount={itemCount}
        totalCount={totalElements}
      />
      <Modal
        nbStep={5}
        onCancel={handleCloseCreateAnnonce}
        open={openCreateAnnonce}
        step={stepModal}
        title={intl.formatMessage({
          id: 'business.annoncesCandidats.publierAnnonceSubTitle',
        })}
      >
        <CreateAnnonce
          onChangeStepModal={setStepModal}
          onClose={handleCloseCreateAnnonce}
          refetchOffre={refetch}
        />
      </Modal>
      <Modal
        onCancel={handleCloseSendMessage}
        open={openSendMessage}
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Envoyez un message aux candidats et gardez contact dans votre
            messagerie
          </div>
        </div>
        <MessageBox id={idSelect} onCancel={handleCloseSendMessage} />
      </Modal>
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={idSelect} />}
      >
        <Profil
          id={idSelect}
          level={levelInterest}
          idOffer={idSelectOffer}
          refetch={refetchCandidatures}
          candidatureResponse={candidatureResponse}
          candidatureRead={candidatureRead}
          acceptCandidature={accepetApplicantCandidature}
          rejectCandidature={rejectApplicantCandidature}
          refetchDashboardInfo={refetch}
          idBusinessExternal={idBusinessExternal}
        />
      </ModalSideBar>
      <ModalStep
        nbStep={2}
        onCancel={handleCloseAddAffiliation}
        open={addModalAffiliation}
        step={stepAffilation}
        title="Formulaire d’affiliation"
        subTitle="Cette affiliation vous permettra d’ajouter l’apprenant à vos affiliations. Ainsi vous pourrez lui demander des documents et finaliser l’affiliation en acceptant de l’intégrer dans une équipe."
      >
        <AffiliationSend
          applicant={selectedApplicant}
          offer={selectedApplicantOffer}
          onChangeStepAffiliation={setStepAffiliation}
          onClose={handleCloseAddAffiliation}
        />
      </ModalStep>
    </Grid>
  );
};

const LevelTraining = ({ id }) => {
  const {
    data: trainings = [],
    refetch: refetchTrainings,
    isFetching: isFetchingTraining,
  } = useQuery(getTrainings, {
    key: 'trainings',
    variables: { id },
  });

  return <div>yes</div>;
};

LevelTraining.propTypes = {
  id: PropTypes.string,
};

const styles = ({ spacing }) => ({
  stepStyles: {
    margin: '10px 0 0 0',
  },
  formations: { flex: 1 },
  btn: {
    marginTop: '20px',
  },
  selectInput: {
    width: '200px',
  }
});

const ImageProfil = ({ applicant }) => {
  const { css } = useStyles();
  const { data: infos = {} } = useQuery(getInfosDashboard, {
    key: ['imageProfile', applicant?.id],
    variables: { id: applicant?.id },
  });

  return infos?.profile?.profileImageUrl ? (
    <Avatar
      className={css({
        height: 50,
        width: 50,
      })}
      src={infos?.profile?.profileImageUrl}
    />
  ) : (
    <Avatar
      className={css({
        height: 50,
        width: 50,
      })}
    >
      {applicant?.lastname?.substr(0, 1)} {applicant?.firstname?.substr(0, 1)}
    </Avatar>
  );
};

ImageProfil.propTypes = {
  applicant: PropTypes.object,
};

export default Candidats;
